import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { InlineSvgModule } from '../inline-svg/index';
import { IconComponent } from './icon.component';

@NgModule({
  exports: [IconComponent],
  imports: [InlineSvgModule, IconComponent],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class IconModule {}
